import { get, patch, post } from "@/helpers/http";
import { localAESStorage } from "@/util/storage";
import md5 from "md5";
/**
 * [注册--- 发送邮箱验证码]
 */
const getEmailVerify = (email, sendType) => {
  return post({
    url: "/api/user/v1/accounts/verification-codes/email",
    data: {
      usage: sendType,
      email: email
    }
  });
};
/**
 * [注册]
 */
const postRegister = (data, type) => {
  const {
    invitation
  } = localAESStorage.getItem("inviteCodeMap") || {};
  data = {
    ...data,
    ...(invitation ? {
      invitation
    } : {}),
    password: md5(data.password),
    appOrigin: 20000
  };
  return post({
    url: "/api/user/v1/accounts/".concat(type),
    data
  });
};
/**
 * [登陆]
 */
const postLogin = (data, type) => {
  const {
    invitation
  } = localAESStorage.getItem("inviteCodeMap") || {};
  if (type === "email") {
    data = {
      ...data,
      password: md5(data.password)
    };
  }
  return post({
    url: "/api/user/v1/accounts/".concat(type, "/login"),
    data: {
      ...data,
      appOrigin: 20000,
      ...(invitation ? {
        invitation
      } : {})
    }
  });
};
/**
 * [退出登陆]
 */
const logOutRequest = () => {
  return get({
    url: "/api/user/v1/logout"
  });
};
/**
 * [查询用户登陆信息]
 */
const getUserInfoV = () => {
  return get({
    url: "/api/user/v1/accounts"
  });
};
/**
 * [重置密码]
 */
const resetAccountRequest = data => {
  data = {
    ...data,
    password: md5(data.password)
  };
  return patch({
    url: "/api/user/v1/password",
    data
  });
};
/**
 * [发送手机验证码]
 */
const postSendPhoneCode = (phone, sendType) => {
  return post({
    url: "/api/user/v1/accounts/verification-codes/phone",
    data: {
      usage: sendType,
      phone: "+86 " + phone
    }
  });
};
export const RegisterApi = {
  getEmailVerify,
  postRegister,
  postLogin,
  logOutRequest,
  getUserInfoV,
  resetAccountRequest,
  postSendPhoneCode
};